import React from 'react';
import { NavigatorContextProvider } from './navigator-context.jsx';
import spatialNavigation from '../../spatial/spatialNavigation';

const Navigator = (props) => {

    let spatial = spatialNavigation;
    if (window.spatial !== null && window.spatial !== undefined) {
        spatial = window.spatial;
    } else {
        window.spatial = spatial;
    }

    return (
        <NavigatorContextProvider value={{ focusTo: spatial.setFocus, navigateByDirection: spatial.navigateByDirection, pauseSpatialNavigation: () => { spatial.enabled = false }, resumeSpatialNavigation: () => { spatial.enabled = true } }}>
            {props.children}
        </NavigatorContextProvider >
    )
}

export default Navigator;